import { BaseDto } from './base.dto';

export class InvoiceStatusDto extends BaseDto {
  name: string;
}
